document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.fhg-carousel-section').forEach(section => {

    const track = section.querySelector('.fhg-carousel-track');
    const btnLeft = section.querySelector('.fhg-carousel-arrow.left');
    const btnRight = section.querySelector('.fhg-carousel-arrow.right');

    if (!track) return;

    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

    const gap = () => {
      const g = getComputedStyle(track).gap;
      return g ? parseInt(g, 10) : 16;
    };

    const step = () => {
      const item = track.querySelector('.fhg-carousel-item');
      return item ? item.offsetWidth + gap() : 0;
    };

    const auto = section.dataset.auto === 'true';
    const pause = parseInt(section.dataset.pause || '2200', 10);

    let pos = 0;
    let timer = null;

    const startAuto = () => {
      if (!auto || !isMobile()) return;

      stopAuto();

      timer = setInterval(() => {
        const s = step();
        if (!s) return;

        pos += s;

        if (pos >= track.scrollWidth - track.clientWidth - s) {
          pos = 0;
        }

        track.scrollTo({ left: pos, behavior: 'smooth' });
      }, pause);
    };

    const stopAuto = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    /* =========================
       MOBILE — AUTO SCROLL
    ========================= */
    const init = () => {

      if (isMobile()) {
        if (btnLeft) btnLeft.style.display = 'none';
        if (btnRight) btnRight.style.display = 'none';

        startAuto();

        track.addEventListener('touchstart', stopAuto, { passive: true });
        track.addEventListener('touchend', startAuto, { passive: true });

      } else {

        stopAuto();

        if (btnLeft && btnRight) {
          btnLeft.style.display = 'flex';
          btnRight.style.display = 'flex';

          btnRight.onclick = () => {
            track.scrollBy({ left: step(), behavior: 'smooth' });
          };

          btnLeft.onclick = () => {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
          };
        }
      }
    };

    init();
    window.addEventListener('resize', init);

  });

});
